export default __webpack_public_path__ + "static/media/M1A_3.4b53dc7b.png";